<template>
  <div class="blogSingle page">
    <div class="blogSingle__inner">
      <div class="blogSingle__breadcrumbs container">
        <breadcrumbs
          :list="[
            {
              url: '/',
              title: 'Ofix',
            },
            {
              to: localePath({ name: 'blog' }),
              title: 'Artykuły i porady',
            },
            {
              title: article.title,
            },
          ]"
          class="searchTemplate__breadcrumbs"
        />
      </div>
      <div class="blogSingle__header">
        <BlogHeader
          :author="article.author"
          :date="article.updatedAt ? article.updatedAt : article.createdAt"
          :image="article.image"
          :title="article.title"
        />
        <div class="blogSingle__tableOfContents">
          <BlogTableOfContents :list="tableOfContents" />
        </div>
      </div>
      <div class="blogSingle__content">
        <BlogSections :sections="article.contentJson.blocks" />
      </div>
      <!--      <LazyHydrate when-visible>-->
      <!--        <flexible-slider-section-->
      <!--          :section="{ title: 'Zobacz również', data: { products: article.similarContent } }"-->
      <!--          content-type="news"-->
      <!--        />-->
      <!--      </LazyHydrate>-->
    </div>
  </div>
</template>

<script>
import BlogSections from '~/components/Editor/Blog/BlogSections';
import Breadcrumbs from '~/components/Breadcrumbs';
import BlogHeader from '~/components/Blog/BlogHeader';
import BlogTableOfContents from '~/components/Blog/BlogTableOfContents';

export default {
  name: 'SinglePost',
  nuxtI18n: {
    paths: {
      pl: '/blog/:slug',
      en: '/blog/:slug',
    },
  },
  components: {
    Breadcrumbs,
    BlogHeader,
    BlogSections,
    BlogTableOfContents,
  },
  async asyncData({ $config, error, $axios, route }) {
    try {
      const {
        data: { content, seo },
      } = await $axios.get(`${$config.baseOfixApi}/e-commerce/v1/contents/${route.params.slug}`, {
        useCache: true,
      });
      return {
        article: content,
        seo,
      };
    } catch {
      error({ statusCode: 404, message: 'Page not found' });
    }
  },
  computed: {
    tableOfContents() {
      return this.article.contentJson.blocks.reduce((filtered, block) => {
        if (block.type === 'header' && block.data.level === 2) {
          filtered.push(block.data.text);
        } else if (block.type === 'FaqSection') {
          filtered.push(block.data.heading);
        }
        return filtered;
      }, []);
    },
  },
  mounted() {
    if (this.$nuxt.$loading._isVue) {
      if (this.$nuxt.$loading.finishCreate()) {
        this.$nuxt.$loading.finishCreate();
      }
    }
  },
  head() {
    const tags = [
      {
        name: 'robots',
        content: 'index, follow',
      },
      {
        content: this.$helper.optimizeImageUrl(this.article.image, 'w_1200,h_627, crop'),
        hid: 'og:image',
        name: 'og:image',
      },
    ];

    return {
      bodyAttrs: {
        class: 'blog-template',
      },
      title: this.seo.title,
      script: [...this.$helper.schemaData(this.seo.schemaOrgData)],
      meta: this.$helper.metaDescription([...tags, ...this.seo.metaTags]),
    };
  },
};
</script>

<style lang="scss">
.blogSingle {
  &__breadcrumbs {
    margin-bottom: 3rem;
  }

  &__header {
    padding: 0 2rem;
    max-width: 1016px;
    margin: 0 auto;
  }

  &__tableOfContents {
    max-width: 90rem;
    margin: 0 auto 5rem;

    @include rwd('small-tablet') {
      margin: 0 auto 4rem;
    }
  }
}
</style>
